import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineAcademicCap } from 'react-icons/hi';
import { HiArrowRight } from 'react-icons/hi2';
import { supabase } from '../../utils/supabase';

function Welcome() {
  const [schoolName, setSchoolName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleNext = async () => {
    if (schoolName.trim() === '') return;
    setLoading(true);
    setError('');

    try {
      const { data, error } = await supabase
        .from('schools')
        .insert({ name: schoolName.trim() })
        .select()
        .single();

      if (error) throw error;

      localStorage.setItem('schoolId', data.id);
      localStorage.setItem('schoolName', data.name);
      navigate('/onboarding/sections');

    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen auth-pattern-bg flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">

        {/* Step Indicator */}
        <div className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center text-sm font-bold">1</div>
          <div className="flex-1 h-1 bg-gray-200 rounded">
            <div className="w-1/3 h-1 bg-blue-500 rounded"></div>
          </div>
          <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-400 flex items-center justify-center text-sm font-bold">2</div>
          <div className="flex-1 h-1 bg-gray-200 rounded"></div>
          <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-400 flex items-center justify-center text-sm font-bold">3</div>
        </div>

        {/* Icon + Heading */}
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
            <HiOutlineAcademicCap className="text-blue-600 text-2xl" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Welcome!</h1>
        </div>
        <p className="text-gray-500 mb-6 ml-1">Let's get your school set up. What's your school called?</p>

        {/* Input */}
        <label className="block text-sm font-medium text-gray-700 mb-1">School Name</label>
        <input
          type="text"
          placeholder="e.g. Greenfield Academy"
          value={schoolName}
          onChange={(e) => setSchoolName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleNext()}
          className="w-full border border-gray-300 rounded-xl px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2"
        />

        {/* Error */}
        {error && (
          <p className="text-red-500 text-sm mb-4">{error}</p>
        )}

        {/* Next Button */}
        <button
          onClick={handleNext}
          disabled={schoolName.trim() === '' || loading}
          className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-gray-200 disabled:text-gray-400 text-white font-semibold py-3 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 mt-4"
        >
          {loading ? 'Saving...' : 'Next'}
          {!loading && <HiArrowRight className="text-lg" />}
        </button>

      </div>
    </div>
  );
}

export default Welcome;
